export const multipliersMenu = [
    {
        id: "device_multipliers",
        label: "Device"
    },
    {
        id: "length_of_stay_multipliers",
        label: "Length Of Stay"
    },
    {
        id: "check_in_day_multipliers",
        label: "Check in day"
    },
    {
        id: "days_to_arrival_multipliers",
        label: "Days to arrival"
    },
    {
        id: "date_type_multipliers",
        label: "Date type"
    },
    {
        id: "need_date_multipliers",
        label: "Check-in Dates"
    }
];

export const multipliersToApi = {
    device_multipliers: "device",
    length_of_stay_multipliers: "los",
    check_in_day_multipliers: "check_in_day",
    days_to_arrival_multipliers: "days_to_arrival",
    date_type_multipliers: "date_type",
    need_date: "need_date_multipliers"
};